import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PlayLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M19.211 11.106 6.737 4.868A1.2 1.2 0 0 0 5 5.942v12.116a1.2 1.2 0 0 0 1.737 1.074l12.474-6.238a1 1 0 0 0 0-1.788" }) }) });
}
const PlayLight = forwardRef(_PlayLight);
export { PlayLight };
